var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.data
    ? _c(
        "div",
        {
          staticClass: "citations-wrapper",
          class: { compact: _vm.compact, open: _vm.isOpen },
          style: { "--citations-width": _vm.width },
        },
        [
          _c(
            "div",
            {
              ref: "citationsBtnRef",
              staticClass: "citations-button",
              on: { click: _vm.showCitations },
            },
            [
              _vm._v(" Sources "),
              _vm.isOpen
                ? _c("span", { staticClass: "close" }, [_vm._v("✖")])
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            { staticClass: "citations-section", class: _vm.alignment },
            [
              _c(
                "ol",
                { staticClass: "citations" },
                _vm._l(_vm.data, function (c, idx) {
                  return _c(
                    "li",
                    { key: idx, staticClass: "citation" },
                    [
                      _vm.hasAuthors(c)
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.formatAuthors(c)) + ". "),
                          ])
                        : _vm._e(),
                      c.organization
                        ? _c("span", [_vm._v(_vm._s(c.organization) + ". ")])
                        : _vm._e(),
                      c.year
                        ? _c("span", [_vm._v("(" + _vm._s(c.year) + "). ")])
                        : _vm._e(),
                      c.title
                        ? _c("em", [_vm._v(_vm._s(c.title) + ". ")])
                        : _vm._e(),
                      c.version
                        ? _c("span", [
                            _c("strong", [_vm._v(_vm._s(c.version))]),
                            _vm._v(". "),
                          ])
                        : _vm._e(),
                      c.url
                        ? [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.renderUrlsInline(c)),
                              },
                            }),
                            _vm._v(". "),
                          ]
                        : _vm._e(),
                      c.accessed
                        ? _c("span", [
                            _vm._v(" Accessed " + _vm._s(c.accessed) + ". "),
                          ])
                        : _vm._e(),
                      c.notes
                        ? _c("div", { staticClass: "notes" }, [
                            _c("small", [_c("em", [_vm._v(_vm._s(c.notes))])]),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }